import { TuneVariantIcon } from './TuneVariantIcon';

/**
 * author: Colton Wiscombe
 * id B0AFC3B0-B718-407F-A51C-F4D932D7FCB2
 * name tune-variant
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tune-variant.svg
 * tags
 * - Audio 
 * - Settings 
 */
export const SliderIcon = TuneVariantIcon;
export default SliderIcon